// extracted by mini-css-extract-plugin
module.exports = {"large-card-wrapper":"ArticlePreviews_large-card-wrapper__3k7A3","small-card-wrapper":"ArticlePreviews_small-card-wrapper__3a7ys"};